/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState, useEffect } from "react";

/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { useDispatch, useSelector } from "react-redux";

import Grid from "@mui/material/Grid2";

import Typography from "@mui/material/Typography";

import GridSectionHeader from "../../../widgets/GridSectionHeader";
import GridTextfield from "../../../widgets/GridTextfield";

import {
  valudateTextfield2,
  validateCurrencyField3,
  removeCommaFromCurrency,
  convertLocaleString,
} from "../../../../utils/fieldValidator.js";

//DATA SLICE - REDUCER
import { updateShortTermLiabilities, updateLongTermLiabilities } from "../../../../states/slcAssetLiability.js";

var stlCreditCardAmountError = "";
var stlBankOverdraftAmountError = "";
var stlOutstandingTaxAmountError = "";
var stlOtherDesc1Error = "";
var stlOtherDesc2Error = "";
var stlOtherDesc3Error = "";
var stlOtherAmt1Error = "";
var stlOtherAmt2Error = "";
var stlOtherAmt3Error = "";

var ltlResMortgageAmountError = "";
var ltlInvMortgageAmountError = "";
var ltlCarLoanAmountError = "";
var ltlOtherDesc1Error = "";
var ltlOtherDesc2Error = "";
var ltlOtherDesc3Error = "";
var ltlOtherAmt1Error = "";
var ltlOtherAmt2Error = "";
var ltlOtherAmt3Error = "";

//TRUE - WHEN COMPONENT IS VALID
var validLiability = true;

export function getLiabilityValidity() {
  return validLiability;
}

export default function Liabilities({ setEnableNext }) {
  const liabilities = useSelector((state) => state.assetliability);

  const [stlCreditCardAmount, setStlCreditCardAmount] = useState(liabilities.stlCreditCardAmount);
  const [stlBankOverdraftAmount, setStlBankOverdraftAmount] = useState(liabilities.stlBankOverdraftAmount);
  const [stlOutstandingTaxAmount, setStlOutstandingTaxAmount] = useState(liabilities.stlOutstandingTaxAmount);
  const [stlOtherDesc1, setStlOtherDesc1] = useState(liabilities.stlOtherDesc1);
  const [stlOtherDesc2, setStlOtherDesc2] = useState(liabilities.stlOtherDesc2);
  const [stlOtherDesc3, setStlOtherDesc3] = useState(liabilities.stlOtherDesc3);
  const [stlOtherAmt1, setStlOtherAmt1] = useState(liabilities.stlOtherAmt1);
  const [stlOtherAmt2, setStlOtherAmt2] = useState(liabilities.stlOtherAmt2);
  const [stlOtherAmt3, setStlOtherAmt3] = useState(liabilities.stlOtherAmt3);
  const [totalShortTermLiability, setTotalShortTermLiability] = useState(liabilities.totalShortTermLiability);

  const [ltlResMortgageAmount, setLtlResMortgageAmount] = useState(liabilities.ltlResMortgageAmount);
  const [ltlInvMortgageAmount, setLtlInvMortgageAmount] = useState(liabilities.ltlInvMortgageAmount);
  const [ltlCarLoanAmount, setLtlCarLoanAmount] = useState(liabilities.ltlCarLoanAmount);
  const [ltlOtherDesc1, setLtlOtherDesc1] = useState(liabilities.ltlOtherDesc1);
  const [ltlOtherDesc2, setLtlOtherDesc2] = useState(liabilities.ltlOtherDesc2);
  const [ltlOtherDesc3, setLtlOtherDesc3] = useState(liabilities.ltlOtherDesc3);
  const [ltlOtherAmt1, setLtlOtherAmt1] = useState(liabilities.ltlOtherAmt1);
  const [ltlOtherAmt2, setLtlOtherAmt2] = useState(liabilities.ltlOtherAmt2);
  const [ltlOtherAmt3, setLtlOtherAmt3] = useState(liabilities.ltlOtherAmt3);
  const [totalLongTermLiability, setLongShortTermLiability] = useState(liabilities.totalLongTermLiability);

  //COMPONENT ID
  let id = "";

  const dispatch = useDispatch();

  //CALCULATES TOTAL SHORT TERM LIABILITY
  useEffect(() => {
    let total =
      Number(removeCommaFromCurrency(stlCreditCardAmount)) +
      Number(removeCommaFromCurrency(stlBankOverdraftAmount)) +
      Number(removeCommaFromCurrency(stlOutstandingTaxAmount)) +
      (stlOtherDesc1 ? Number(removeCommaFromCurrency(stlOtherAmt1)) : 0) +
      (stlOtherDesc2 ? Number(removeCommaFromCurrency(stlOtherAmt2)) : 0) +
      (stlOtherDesc3 ? Number(removeCommaFromCurrency(stlOtherAmt3)) : 0);

    total = convertLocaleString(total, "en-US", 2);

    setTotalShortTermLiability(total);
    updateRedux("totalShortTermLiability", total, updateShortTermLiabilities);
  }, [
    stlCreditCardAmount,
    stlBankOverdraftAmount,
    stlOutstandingTaxAmount,
    stlOtherDesc1,
    stlOtherDesc2,
    stlOtherDesc3,
    stlOtherAmt1,
    stlOtherAmt2,
    stlOtherAmt3,
  ]);

  //CALCULATES TOTAL LONG TERM LIABILITY
  useEffect(() => {
    let total =
      Number(removeCommaFromCurrency(ltlResMortgageAmount)) +
      Number(removeCommaFromCurrency(ltlInvMortgageAmount)) +
      Number(removeCommaFromCurrency(ltlCarLoanAmount)) +
      (ltlOtherDesc1 ? Number(removeCommaFromCurrency(ltlOtherAmt1)) : 0) +
      (ltlOtherDesc2 ? Number(removeCommaFromCurrency(ltlOtherAmt2)) : 0) +
      (ltlOtherDesc3 ? Number(removeCommaFromCurrency(ltlOtherAmt3)) : 0);

    total = convertLocaleString(total, "en-US", 2);

    setLongShortTermLiability(total);
    updateRedux("totalLongTermLiability", total, updateLongTermLiabilities);
  }, [
    ltlResMortgageAmount,
    ltlInvMortgageAmount,
    ltlCarLoanAmount,
    ltlOtherDesc1,
    ltlOtherDesc2,
    ltlOtherDesc3,
    ltlOtherAmt1,
    ltlOtherAmt2,
    ltlOtherAmt3,
  ]);

  function updateRedux(fieldName, fieldValue, reducer) {
    const action = {
      type: fieldName,
      payload: fieldValue,
    };
    dispatch(reducer(action));
  }

  function handleChange(e, object) {
    let input_data = {
      event: e,
      fieldName: "",
      fieldVariable: "",
      isMandatory: false,
    };

    //TEXTFIELDS
    id = e.target.id;
    validateShortTermLiabilities(e, id, input_data);
    validateLongTermLiabilities(e, id, input_data);
    validateSummary(e, id, input_data);

    calculateValidity();
  }

  function validateSummary(e, id, input_data) {
    //     if (id === "selectedClient") {
    //   setIsSelectedClient(e.target.checked);
    //   isSelectedClientError = "";
    // }
  }

  function validateShortTermLiabilities(e, id, input_data) {
    if (id === "stlCreditCardAmount") {
      input_data.fieldName = "Credit card";
      input_data.fieldVariable = stlCreditCardAmount;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setStlCreditCardAmount(result.value);
        updateRedux("stlCreditCardAmount", result.value, updateShortTermLiabilities);
      } else stlCreditCardAmountError = result.errorMessage;
    }

    if (id === "stlBankOverdraftAmount") {
      input_data.fieldName = "Residential mortgage";
      input_data.fieldVariable = stlBankOverdraftAmount;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setStlBankOverdraftAmount(result.value);
        updateRedux("stlBankOverdraftAmount", result.value, updateShortTermLiabilities);
      } else stlBankOverdraftAmountError = result.errorMessage;
    }

    if (id === "stlOutstandingTaxAmount") {
      input_data.fieldName = "Investment mortgage";
      input_data.fieldVariable = stlOutstandingTaxAmount;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setStlOutstandingTaxAmount(result.value);
        updateRedux("stlOutstandingTaxAmount", result.value, updateShortTermLiabilities);
      } else stlOutstandingTaxAmountError = result.errorMessage;
    }

    if (id === "stlOtherDesc1") {
      input_data.fieldName = "Reason";
      input_data.fieldVariable = stlOtherDesc1;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setStlOtherDesc1(result.value);
        updateRedux("stlOtherDesc1", result.value, updateShortTermLiabilities);
      } else stlOtherDesc1Error = result.errorMessage;
    }

    if (id === "stlOtherDesc2") {
      input_data.fieldName = "Reason";
      input_data.fieldVariable = stlOtherDesc2;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setStlOtherDesc2(result.value);
        updateRedux("stlOtherDesc2", result.value, updateShortTermLiabilities);
      } else stlOtherDesc2Error = result.errorMessage;
    }

    if (id === "stlOtherDesc3") {
      input_data.fieldName = "Reason";
      input_data.fieldVariable = stlOtherDesc3;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setStlOtherDesc3(result.value);
        updateRedux("stlOtherDesc3", result.value, updateShortTermLiabilities);
      } else stlOtherDesc3Error = result.errorMessage;
    }

    if (id === "stlOtherAmt1") {
      input_data.fieldName = "Liability amount 1";
      input_data.fieldVariable = stlOtherAmt1;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setStlOtherAmt1(result.value);
        updateRedux("stlOtherAmt1", result.value, updateShortTermLiabilities);
      } else stlOtherAmt1Error = result.errorMessage;
    }

    if (id === "stlOtherAmt2") {
      input_data.fieldName = "Liability amount 2";
      input_data.fieldVariable = stlOtherAmt2;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setStlOtherAmt2(result.value);
        updateRedux("stlOtherAmt2", result.value, updateShortTermLiabilities);
      } else stlOtherAmt2Error = result.errorMessage;
    }

    if (id === "stlOtherAmt3") {
      input_data.fieldName = "Liability amount 3";
      input_data.fieldVariable = stlOtherAmt3;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setStlOtherAmt3(result.value);
        updateRedux("stlOtherAmt3", result.value, updateShortTermLiabilities);
      } else stlOtherAmt3Error = result.errorMessage;
    }
  }

  function validateLongTermLiabilities(e, id, input_data) {
    if (id === "ltlResMortgageAmount") {
      input_data.fieldName = "Mortage - Residential Property";
      input_data.fieldVariable = ltlResMortgageAmount;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setLtlResMortgageAmount(result.value);
        updateRedux("ltlResMortgageAmount", result.value, updateLongTermLiabilities);
      } else ltlResMortgageAmountError = result.errorMessage;
    }

    if (id === "ltlInvMortgageAmount") {
      input_data.fieldName = "Mortage - Investment Property";
      input_data.fieldVariable = ltlInvMortgageAmount;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setLtlInvMortgageAmount(result.value);
        updateRedux("ltlInvMortgageAmount", result.value, updateLongTermLiabilities);
      } else ltlInvMortgageAmountError = result.errorMessage;
    }

    if (id === "ltlCarLoanAmount") {
      input_data.fieldName = "Car Loan";
      input_data.fieldVariable = ltlCarLoanAmount;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setLtlCarLoanAmount(result.value);
        updateRedux("ltlCarLoanAmount", result.value, updateLongTermLiabilities);
      } else ltlCarLoanAmountError = result.errorMessage;
    }

    if (id === "ltlOtherDesc1") {
      input_data.fieldName = "Reason";
      input_data.fieldVariable = ltlOtherDesc1;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setLtlOtherDesc1(result.value);
        updateRedux("ltlOtherDesc1", result.value, updateLongTermLiabilities);
      } else ltlOtherDesc1Error = result.errorMessage;
    }

    if (id === "ltlOtherDesc2") {
      input_data.fieldName = "Reason";
      input_data.fieldVariable = ltlOtherDesc2;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setLtlOtherDesc2(result.value);
        updateRedux("ltlOtherDesc2", result.value, updateLongTermLiabilities);
      } else ltlOtherDesc2Error = result.errorMessage;
    }

    if (id === "ltlOtherDesc3") {
      input_data.fieldName = "Reason";
      input_data.fieldVariable = ltlOtherDesc3;
      const result = valudateTextfield2(input_data);

      if (result.errorMessage === "") {
        setLtlOtherDesc3(result.value);
        updateRedux("ltlOtherDesc3", result.value, updateLongTermLiabilities);
      } else ltlOtherDesc3Error = result.errorMessage;
    }

    if (id === "ltlOtherAmt1") {
      input_data.fieldName = "Liability amount 1";
      input_data.fieldVariable = ltlOtherAmt1;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setLtlOtherAmt1(result.value);
        updateRedux("ltlOtherAmt1", result.value, updateLongTermLiabilities);
      } else ltlOtherAmt1Error = result.errorMessage;
    }

    if (id === "ltlOtherAmt2") {
      input_data.fieldName = "Liability amount 2";
      input_data.fieldVariable = ltlOtherAmt2;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setLtlOtherAmt2(result.value);
        updateRedux("ltlOtherAmt2", result.value, updateLongTermLiabilities);
      } else ltlOtherAmt2Error = result.errorMessage;
    }

    if (id === "ltlOtherAmt3") {
      input_data.fieldName = "Liability amount 3";
      input_data.fieldVariable = ltlOtherAmt3;
      const result = validateCurrencyField3(input_data);

      if (result.errorMessage === "") {
        setLtlOtherAmt3(result.value);
        updateRedux("ltlOtherAmt3", result.value, updateLongTermLiabilities);
      } else ltlOtherAmt3Error = result.errorMessage;
    }
  }

  function calculateValidity() {
    validLiability = false;

    if (
      stlOtherDesc1Error.length !== 0 ||
      stlOtherDesc2Error.length !== 0 ||
      stlOtherDesc3Error.length !== 0 ||
      ltlOtherDesc1Error.length !== 0 ||
      ltlOtherDesc2Error.length !== 0 ||
      ltlOtherDesc3Error.length !== 0
    ) {
      setEnableNext(false);
      return;
    }

    validLiability = true;
    setEnableNext(true);
  }

  return (
    <Grid container spacing={2}>
      <GridSectionHeader
        sectionName="Liabilities"
        sx={{
          p: 1,
          pl: 1.8,
          mt: 0,
          mb: 1,
          fontSize: 18,
          fontWeight: "bold",
          color: "#FFFFFF", //WHITE
          // color: "#000000", //BLACK
          // backgroundColor: "#d9d9d9",
          backgroundColor: "#10B981",
        }}
      />
      {/**==================================================
       * Short Term Liabilities
       ==================================================*/}
      <Grid size={12}>
        <Typography variant="h6" gutterBottom sx={{ backgroundColor: "lightgray" }}>
          Short Term <b>Total: ${totalShortTermLiability}</b>
        </Typography>
      </Grid>
      <GridTextfield
        id="stlCreditCardAmount"
        key="stlCreditCardAmount"
        required={false}
        columnSize="6"
        label="Credit Card(s)"
        currState={stlCreditCardAmount}
        onChange={handleChange}
        isCurrency={true}
        error={stlCreditCardAmountError}
        helperText={stlCreditCardAmountError}
      />
      <GridTextfield
        id="stlBankOverdraftAmount"
        key="stlBankOverdraftAmount"
        required={false}
        columnSize="6"
        label="Bank Overdeaft"
        currState={stlBankOverdraftAmount}
        onChange={handleChange}
        isCurrency={true}
        error={stlBankOverdraftAmountError}
        helperText={stlBankOverdraftAmountError}
      />
      <GridTextfield
        id="stlOutstandingTaxAmount"
        key="stlOutstandingTaxAmount"
        required={false}
        columnSize="12"
        label="Outstanding Tax"
        currState={stlOutstandingTaxAmount}
        onChange={handleChange}
        isCurrency={true}
        error={stlOutstandingTaxAmountError}
        helperText={stlOutstandingTaxAmountError}
      />
      <GridTextfield
        id="stlOtherDesc1"
        key="stlOtherDesc1"
        required={false}
        columnSize="6"
        label="Other - Liability 1"
        currState={stlOtherDesc1}
        onChange={handleChange}
        error={stlOtherDesc1Error}
        helperText={stlOtherDesc1Error}
      />
      <GridTextfield
        id="stlOtherAmt1"
        key="stlOtherAmt1"
        required={false}
        columnSize="6"
        label="Other - Liability Amount 1"
        currState={stlOtherAmt1}
        onChange={handleChange}
        isCurrency={true}
        error={stlOtherAmt1Error}
        helperText={stlOtherAmt1Error}
      />
      <GridTextfield
        id="stlOtherDesc2"
        key="stlOtherDesc2"
        required={false}
        columnSize="6"
        label="Other - Liability 2"
        currState={stlOtherDesc2}
        onChange={handleChange}
        error={stlOtherDesc2Error}
        helperText={stlOtherDesc2Error}
      />
      <GridTextfield
        id="stlOtherAmt2"
        key="stlOtherAmt2"
        required={false}
        columnSize="6"
        label="Other - Liability Amount 2"
        currState={stlOtherAmt2}
        onChange={handleChange}
        isCurrency={true}
        error={stlOtherAmt2Error}
        helperText={stlOtherAmt2Error}
      />
      <GridTextfield
        id="stlOtherDesc3"
        key="stlOtherDesc3"
        required={false}
        columnSize="6"
        label="Other - Liability 3"
        currState={stlOtherDesc3}
        onChange={handleChange}
        error={stlOtherDesc3Error}
        helperText={stlOtherDesc3Error}
      />
      <GridTextfield
        id="stlOtherAmt3"
        key="stlOtherAmt3"
        required={false}
        columnSize="6"
        label="Other - Liability Amount 3"
        currState={stlOtherAmt3}
        onChange={handleChange}
        isCurrency={true}
        error={stlOtherAmt3Error}
        helperText={stlOtherAmt3Error}
      />

      {/**==================================================
       * Long Term Liabilities
       ==================================================*/}
      <Grid size={12}>
        <Typography variant="h6" gutterBottom sx={{ backgroundColor: "lightgray" }}>
          Long Term <b>Total: ${totalLongTermLiability}</b>
        </Typography>
      </Grid>
      <GridTextfield
        id="ltlResMortgageAmount"
        key="ltlResMortgageAmount"
        columnSize="6"
        label="Mortage - Residential Property"
        currState={ltlResMortgageAmount}
        onChange={handleChange}
        isCurrency={true}
        error={ltlResMortgageAmountError}
        helperText={ltlResMortgageAmountError}
      />
      <GridTextfield
        id="ltlInvMortgageAmount"
        key="ltlInvMortgageAmount"
        columnSize="6"
        label="Mortage - Investment Property"
        currState={ltlInvMortgageAmount}
        onChange={handleChange}
        isCurrency={true}
        error={ltlInvMortgageAmountError}
        helperText={ltlInvMortgageAmountError}
      />
      <GridTextfield
        id="ltlCarLoanAmount"
        key="ltlCarLoanAmount"
        columnSize="12"
        label="Car Loan"
        currState={ltlCarLoanAmount}
        onChange={handleChange}
        isCurrency={true}
        error={ltlCarLoanAmountError}
        helperText={ltlCarLoanAmountError}
      />

      <GridTextfield
        id="ltlOtherDesc1"
        key="ltlOtherDesc1"
        required={false}
        columnSize="6"
        label="Other - Liability 1"
        currState={ltlOtherDesc1}
        onChange={handleChange}
        error={ltlOtherDesc1Error}
        helperText={ltlOtherDesc1Error}
      />
      <GridTextfield
        id="ltlOtherAmt1"
        key="ltlOtherAmt1"
        required={false}
        columnSize="6"
        label="Other - Liability Amount 1"
        currState={ltlOtherAmt1}
        onChange={handleChange}
        isCurrency={true}
        error={ltlOtherAmt1Error}
        helperText={ltlOtherAmt1Error}
      />
      <GridTextfield
        id="ltlOtherDesc2"
        key="ltlOtherDesc2"
        required={false}
        columnSize="6"
        label="Other - Liability 2"
        currState={ltlOtherDesc2}
        onChange={handleChange}
        error={ltlOtherDesc2Error}
        helperText={ltlOtherDesc2Error}
      />
      <GridTextfield
        id="ltlOtherAmt2"
        key="ltlOtherAmt2"
        required={false}
        columnSize="6"
        label="Other - Liability Amount 2"
        currState={ltlOtherAmt2}
        onChange={handleChange}
        isCurrency={true}
        error={ltlOtherAmt2Error}
        helperText={ltlOtherAmt2Error}
      />
      <GridTextfield
        id="ltlOtherDesc3"
        key="ltlOtherDesc3"
        required={false}
        columnSize="6"
        label="Other - Liability 3"
        currState={ltlOtherDesc3}
        onChange={handleChange}
        error={ltlOtherDesc3Error}
        helperText={ltlOtherDesc3Error}
      />
      <GridTextfield
        id="ltlOtherAmt3"
        key="ltlOtherAmt3"
        required={false}
        columnSize="6"
        label="Other - Liability Amount 3"
        currState={ltlOtherAmt3}
        onChange={handleChange}
        isCurrency={true}
        error={ltlOtherAmt3Error}
        helperText={ltlOtherAmt3Error}
      />
    </Grid>
  );
}
